import React from 'react';
import { useBasicDetails } from '../../store';
import { verticalTimeline } from '../styles/verticalTimeline';

const DownArrow = (): JSX.Element => {
  const {
    template: {
      settings: {
        page: { timeline },
      },
    },
  } = useBasicDetails();

  const classes = verticalTimeline(timeline);
  return (
    <div className={classes.circle}>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <g id="icon/navigation/chevron_right_24px">
          <path
            id="icon/navigation/chevron_right_24px_2"
            d="M25.6465 12.7639C25.8418 12.5686 25.8418 12.252 25.6465 12.0568L24.9432 11.3535C24.7481 11.1584 24.4318 11.1582 24.2365 11.3531L20.3532 15.2279C20.1581 15.4227 19.8421 15.4227 19.6469 15.2279L15.7636 11.3531C15.5683 11.1582 15.252 11.1584 15.0569 11.3535L14.3536 12.0568C14.1584 12.252 14.1584 12.5686 14.3536 12.7639L19.6465 18.0568C19.8418 18.252 20.1584 18.252 20.3536 18.0568L25.6465 12.7639Z"
            fill="currentColor"
            className={`${classes.animated} ${classes.bounce}`}
          />

          <path
            id="icon/navigation/chevron_right_24px_3"
            d="M25.6465 18.7639C25.8418 18.5686 25.8418 18.252 25.6465 18.0568L24.9432 17.3535C24.7481 17.1584 24.4318 17.1582 24.2365 17.3531L20.3532 21.2279C20.1581 21.4227 19.8421 21.4227 19.6469 21.2279L15.7636 17.3531C15.5683 17.1582 15.252 17.1584 15.0569 17.3535L14.3536 18.0568C14.1584 18.252 14.1584 18.5686 14.3536 18.7639L19.6465 24.0568C19.8418 24.252 20.1584 24.252 20.3536 24.0568L25.6465 18.7639Z"
            fill="currentColor"
            className={`${classes.animated} ${classes.bounce}`}
          />
        </g>
      </svg>
    </div>
  );
};
export default DownArrow;
